export enum eHoaDonLogType {
    TAO_MOI = 1,
    GUI_CQT = 2,
    CQT_TU_CHOI = 3,
    CQT_DONG_Y = 4,
    CAP_NHAT = 5,
    KY = 6
}